'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import EventSettingsData from 'AdsUI/data/EventSettingsData';
import Actions from 'AdsUI/lib/Actions';
import { getPixels } from 'AdsUI/data/AudiencesData';
export const fetchEventList = () => {
  return dispatch => {
    return wrapReduxAction(EventSettingsData.getEventList.bind(EventSettingsData), 'EVENTS_FETCH', {
      dispatch,
      returnPromise: true
    });
  };
};
export const createManyEvents = (network, accountId, events) => {
  return dispatch => {
    return wrapReduxAction(EventSettingsData.createManyEvents.bind(null, network, accountId, events), Actions.CREATE_MANY_EVENTS, {
      dispatch,
      returnPromise: true
    });
  };
};
export const createOfflineEvent = (network, accountId, eventOpts) => {
  return dispatch => {
    return wrapReduxAction(EventSettingsData.createOfflineEvent.bind(EventSettingsData, network, accountId, eventOpts), 'OFFLINE_EVENT_CREATE', {
      dispatch,
      returnPromise: true
    });
  };
};
export const updateEvent = (eventId, eventOpts) => {
  return dispatch => {
    return wrapReduxAction(EventSettingsData.updateEvent.bind(EventSettingsData, eventId, eventOpts), 'EVENT_UPDATE', {
      dispatch,
      returnPromise: true,
      allParams: Object.assign({
        eventId
      }, eventOpts)
    });
  };
};
export const deleteEvent = (eventId, returnPromise = false) => dispatch => wrapReduxAction(EventSettingsData.deleteEvent.bind(null, eventId), 'EVENT_DELETE', {
  dispatch,
  returnPromise,
  allParams: {
    eventId
  }
});
export const openEventPanel = () => {
  return dispatch => dispatch({
    type: Actions.OPEN_EVENT_PANEL
  });
};
export const replaceEvent = eventToReplace => {
  return dispatch => dispatch({
    type: Actions.REPLACE_EVENT,
    payload: {
      eventToReplace
    }
  });
};
export const closeEventPanel = () => {
  return dispatch => dispatch({
    type: Actions.CLOSE_EVENT_PANEL
  });
};
export const openEventPanelType = panel => {
  return dispatch => dispatch({
    type: Actions.OPEN_EVENT_PANEL_TYPE,
    payload: {
      panel
    }
  });
};
export const fetchPixelEventCount = () => {
  return dispatch => {
    return wrapReduxAction(getPixels.bind(null, {
      includeOnlyInstalled: true
    }), 'PIXELS_EVENT_COUNT_FETCH', {
      dispatch
    });
  };
};